// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSAvatar/index.less
// module id = 702
// module chunks = 42